"use client";

import { usePathname } from "next/navigation";
import { createContext, type ReactNode, useContext, useMemo } from "react";
import type { ReaderReportType } from "@/lib/reports/report-type";
import {
  buildPublicExplorePathPrefix,
  parseReportTypeFromPathname,
} from "./explore-routes";

interface ExploreRouteContextValue {
  reportType: ReaderReportType;
  exploreBase: string;
}

const ExploreRouteContext = createContext<ExploreRouteContextValue | null>(
  null
);

export function ExploreRouteProvider({ children }: { children: ReactNode }) {
  const pathname = usePathname();

  const value = useMemo<ExploreRouteContextValue>(() => {
    const reportType = parseReportTypeFromPathname({ pathname });
    return {
      reportType,
      exploreBase: buildPublicExplorePathPrefix({ reportType }),
    };
  }, [pathname]);

  return (
    <ExploreRouteContext.Provider value={value}>
      {children}
    </ExploreRouteContext.Provider>
  );
}

export function useExploreRoute(): ExploreRouteContextValue {
  const value = useContext(ExploreRouteContext);
  if (!value) {
    throw new Error("useExploreRoute must be used within ExploreRouteProvider");
  }
  return value;
}
